<template>
    <f7-page
        name="Partner Subscriptions"
        class="onboardingBg"
    >
        <f7-navbar
            large
            title-large=""
            large-transparent
            inner-class="onboardingBg"
        >
            <f7-nav-left>
                <f7-link
                    icon="ion-ios-arrow-left"
                    @click="goBack"
                />
            </f7-nav-left>
            <f7-nav-title />
        </f7-navbar>

        <f7-block style="padding: 30px 16px 0; margin-top: -20px; text-align: left">

            <h2 style="text-align: left">Partner Subscriptions</h2>
            <p>
                Thanks to your partner, you have free unlimited access to all Coral content.
            </p>
            <p>
                If you or your partner decided to break up, you can break the connection between your accounts in your account profile area.
            </p>
            <p>
                When that happens, you will continue to have access to our freemium content only.
            </p>
            <br>

        </f7-block>

    </f7-page>
</template>

<script>
export default {
    store: ['api'],
    data () {
        return {};
    },
    computed: {
        device: function () {
            return f7.device;
        },
        isPgap: function () {
            return !!pgap;
        },
        isApple: function () {
            return pgap && device.platform === 'iOS';
        },
        isAndroid: function () {
            return pgap && device.platform === 'Android';
        }
    },
    created: function () { },
    mounted: function () { },
    methods: {
        goBack: function () {
            if (f7.views['main'].router.history.length === 1) {
                return f7.views['main'].router.navigate('/home', { clearPreviousHistory: true });
            }
            return f7.views['main'].router.back();
        }
    }
};
</script>

<style lang="less" scoped>
.center {
    text-align: center;
}
</style>
